import { mdiInformationOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { FunctionComponent, useEffect, useState } from "react";
import {
  PurchaseOrderModelV2,
  approval_level,
  approval_threshold,
  getPoApprovedCounts,
  levelModule,
} from "../../model/purchase_order_model";
import { useHistory } from "react-router-dom";
import { urls } from "../../../../utils/urls";
import StepperWidget from "../../../../ui/new_components/common/stepper_widget";
import { useAuth } from "../../../../context_providers/auth/authProvider";
import {
  useModal,
  ModalType,
  ModalAlignment,
} from "../../../../context_providers/modal/modal_context";
import { ACTION, MODULE, PO_STATUS } from "../../../../utils/enums";
import ApprovalData from "../../purchase_order_approval/components/approval_data_sheet";
import {
  ToastType,
  useToast,
} from "../../../../context_providers/toast/toast_ctx";
import ModalDialog from "../../../../ui/new_components/common/modal";
import { GetOnboardedWarehouseVendorApi } from "../../../inventory/inventory_basket/components/warehouse_repo";
import {
  closePORepo,
  getPOClosePreviewRepo,
  POClosePreview,
} from "../service/po_service";

const inr = (n: number) =>
  `₹${(Math.round((n || 0) * 100) / 100).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
  })}`;

interface PoCreateBottomSheetWidgetProps {
  data: PurchaseOrderModelV2;
  onSubmit?: () => void;
  onSaveDraft?: () => void;
}

const PoViewBottomSheetWidget: FunctionComponent<
  PoCreateBottomSheetWidgetProps
> = (props) => {
  const navigation = useHistory();
  const { isAuthorised } = useAuth();
  const { showModal } = useModal();
  const [showActionBtn, setshowActionBtn] = useState(false);
  const navaigation = useHistory();
  const [showItemsModal, setShowItemsModal] = useState(false);
  const { showToast } = useToast();
  const [forecloseMessage, setForecloseMessage] = useState(
    props.data.foreclose_message || "",
  );

  const [approvalCounts, setapprovalCounts] = useState<{
    [key: string]: number;
  }>({});
  const [approvalLevels, setapprovalLevels] = useState<{
    [key: string]: number;
  }>({});
  const [procuremntRead, setProcurementRead] = useState(false);

  const [closePreview, setClosePreview] = useState<POClosePreview | null>(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [closing, setClosing] = useState(false);

  const openCloseModal = async () => {
    setShowItemsModal(true);
    setClosePreview(null);
    setPreviewLoading(true);
    try {
      const res = await getPOClosePreviewRepo(props.data.id);
      if (res.success) setClosePreview(res.data);
      else showToast({ type: ToastType.error, text: res.error ?? res.message });
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
    }
    setPreviewLoading(false);
  };

  const isShortClose = closePreview?.mode === "short";
  const canConfirm =
    !!closePreview?.eligible &&
    !closing &&
    (!isShortClose || forecloseMessage.trim().length > 0);

  const handleItemsModal = async () => {
    if (!canConfirm) return;
    setClosing(true);
    try {
      const res = await closePORepo(props.data.id, forecloseMessage.trim());
      if (res.success) {
        setShowItemsModal(false);
        showToast({ type: ToastType.success, text: res.message });
        navaigation.push(urls.purchase_order);
      } else {
        showToast({ type: ToastType.error, text: res.error ?? res.message });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
    }
    setClosing(false);
  };

  const [onboardedVendor, setOnboardedVendor] = useState<boolean>(false);
  useEffect(() => {
    const fetchOnboardedStatus = async () => {
      if (props?.data?.warehouse?.id) {
        const result = await GetOnboardedWarehouseVendorApi(
          props.data.warehouse.id,
        );
        if (result.onboarded) {
          setOnboardedVendor(true);
        } else setOnboardedVendor(false);
      }
    };

    fetchOnboardedStatus();

    setForecloseMessage(props.data.foreclose_message || "");
  }, [props.data.foreclose_message, props?.data?.warehouse?.id]);

  useEffect(() => {
    const counts = getPoApprovedCounts({ approvals: props.data.approvals });
    setapprovalCounts(counts);

    const rule =
      approval_threshold[props.data.approval_level || approval_level.level_0];

    const t = rule.approvals_required.reduce(
      (
        pv: {
          [key: string]: number;
        },
        v: { level: string; count: number },
      ) => ({ ...pv, [v.level]: v.count }),
      {},
    );
    setapprovalLevels(t);
  }, [props.data]);

  useEffect(() => {
    const procuremnt_read_only = isAuthorised({
      module: MODULE.procurement_read_only,
      action: ACTION.READ,
    });

    setProcurementRead(procuremnt_read_only);

    setshowActionBtn(
      (props.data.current_approval_required_count ?? 0) >
        (props.data.current_approval_count ?? 0) &&
        isAuthorised({
          action: ACTION.READ,
          module: levelModule[props.data.current_approval_level!],
        }),
    );
  }, [props.data]);

  const levels = Object.keys(approvalLevels);

  return (
    <div className="">
      {props.data.approval_level !== approval_level.level_0 && (
        <div className="mt-2 border rounded-md p-2 bg-gray-50 mb-2">
          <div className="pb-5">
            <StepperWidget
              steps={levels.map((level, i) => ({
                label: level,
                validated:
                  i < levels.indexOf(props.data.current_approval_level!) ||
                  (props.data.approval_level ===
                    props.data.current_approval_level &&
                    (props.data.current_approval_count ?? 0) >=
                      (props.data.current_approval_required_count ?? 0)),
                required: false,
              }))}
              activeStep={levels.indexOf(props.data.current_approval_level!)}
              onChange={function (step: number): void {
                showModal({
                  container: (i) => (
                    <div className="p-5">
                      <ApprovalData
                        approvals={
                          props.data.approvals?.filter(
                            (f) => f.level == levels[step],
                          ) ?? []
                        }
                        approved_count={approvalCounts[levels[step]] ?? 0}
                        approval_count_required={approvalLevels[levels[step]]}
                        approval_level={levels[step]}
                      />
                    </div>
                  ),
                  title: `${levels[step]} Approval Detail`,
                  type: ModalType.drawer,
                  alignment: ModalAlignment.right,
                });
              }}
            />
          </div>
        </div>
      )}
      {showItemsModal && (
        <ModalDialog
          title=""
          onClose={() => setShowItemsModal(false)}
          show={true}
        >
          {previewLoading && (
            <p className="text-sm text-gray-500">Checking receipts and invoices…</p>
          )}

          {closePreview && (
            <div className="text-sm">
              <p className="font-semibold">
                {isShortClose
                  ? `Short close — ${inr(closePreview.balance_value)} of unreceived value will be returned to the project budget.`
                  : "Everything on this PO has been received — this is a normal close; no budget is returned."}
              </p>

              <table className="min-w-full mt-3 border-collapse text-xs">
                <thead>
                  <tr>
                    <th className="border px-2 py-1 text-left">Item</th>
                    <th className="border px-2 py-1 text-left">Project</th>
                    <th className="border px-2 py-1 text-right">Ordered</th>
                    <th className="border px-2 py-1 text-right">Received</th>
                    <th className="border px-2 py-1 text-right">Received value</th>
                    <th className="border px-2 py-1 text-right">Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {closePreview.lines.map((l, i) => (
                    <tr key={i}>
                      <td className="border px-2 py-1">
                        {l.item_name || l.item_code}
                      </td>
                      <td className="border px-2 py-1">
                        {l.project_name ?? l.project_id}
                      </td>
                      <td className="border px-2 py-1 text-right">{l.ordered_qty}</td>
                      <td className="border px-2 py-1 text-right">{l.received_qty}</td>
                      <td className="border px-2 py-1 text-right">
                        {inr(l.received_value)}
                      </td>
                      <td className="border px-2 py-1 text-right">
                        {inr(l.balance_value)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {isShortClose && (
                <div className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1 border rounded-md p-2 bg-gray-50">
                  <span>Received value (GRN qty × price + GST)</span>
                  <span className="text-right">{inr(closePreview.received_value)}</span>
                  <span>
                    Payment Requests ({closePreview.invoice_count} PR(s), any
                    type)
                  </span>
                  <span className="text-right">{inr(closePreview.invoiced_amount)}</span>
                  <span>Difference (±₹1 allowed)</span>
                  <span className="text-right">{inr(closePreview.difference)}</span>
                  <span>Paid to vendor</span>
                  <span className="text-right">{inr(closePreview.paid_amount)}</span>
                  {closePreview.project_credits.map((c) => (
                    <span key={c.project_id} className="col-span-2 text-green-700">
                      {inr(c.amount)} back to {c.project_name ?? c.project_id}
                    </span>
                  ))}
                </div>
              )}

              {!closePreview.eligible && (
                <div className="mt-3 border border-red-300 bg-red-50 rounded-md p-2 text-red-700">
                  <p className="font-semibold">This PO can't be closed yet:</p>
                  <ul className="list-disc ml-5">
                    {closePreview.reasons.map((r, i) => (
                      <li key={i}>{r}</li>
                    ))}
                  </ul>
                </div>
              )}

              {closePreview.eligible && (
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700">
                    {isShortClose
                      ? "Reason for short close (required — shown to finance in the PO export)"
                      : "Close remark (optional)"}
                  </label>
                  <input
                    type="text"
                    value={forecloseMessage}
                    onChange={(e) => setForecloseMessage(e.target.value)}
                    className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md"
                    placeholder="Enter remark"
                  />
                </div>
              )}
            </div>
          )}

          <div className="items-center flex justify-center mt-4">
            <button
              className={`border rounded-3xl px-5 py-2 mt-2 ${
                canConfirm
                  ? "text-green-800 hover:bg-green-600 hover:text-white border-green-400"
                  : "text-gray-400 border-gray-300 cursor-not-allowed"
              }`}
              disabled={!canConfirm}
              onClick={handleItemsModal}
            >
              {closing
                ? "Closing…"
                : isShortClose
                  ? "Short close PO"
                  : "Close PO"}
            </button>
          </div>
        </ModalDialog>
      )}
      <div className="flex flex-col md:flex-row md:justify-between gap-2">
        <div className="">
          <div className="flex gap-1 text-gray-500 text-xs mt-2 items-center">
            <Icon path={mdiInformationOutline} size={0.8}></Icon>
            This Purchase order requires {props.data.approval_level} approval
          </div>
        </div>

        <div className="text-sm font-semibold flex flex-wrap gap-2 items-center justify-end">
          {!procuremntRead && (
            <>
              {props.data.current_approval_level ===
                props.data.approval_level &&
                props.data.current_approval_count ===
                  props.data.current_approval_required_count &&
                props.data.po_no &&
                props.data.status !== PO_STATUS.closed && (
                  <button
                    onClick={openCloseModal}
                    className={`text-center px-3 py-1 rounded-md bg-myPrimaryColor text-white text-sm ${
                      props.data.items.reduce((acc, next) => {
                        acc += next.unit_no - 0;
                        return acc;
                      }, 0) === 0
                        ? "hidden"
                        : ""
                    }`}
                  >
                    Close PO
                  </button>
                )}
            </>
          )}

          <div className="flex justify-end gap-2">
            <button
              onClick={() => {
                navigation.goBack();
              }}
              type="button"
              className="rounded-md border border-green-600 text-sm font-semibold bg-white text-black px-3 py-1 shadow-md"
            >
              Quit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoViewBottomSheetWidget;
